var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form',{ref:"formValidate",attrs:{"model":_vm.params,"inline":"","label-width":"80px"}},[_c('el-form-item',{attrs:{"label":"","prop":"roleName"}},[_c('el-tree',{ref:"roleTree",attrs:{"data":_vm.tempData,"props":_vm.defaultProps,"node-key":"id","show-checkbox":"","default-expand-all":""}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf927440","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/userAllotRole/src/main.vue
// module id = null
// module chunks = 